import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {ApiService} from '../api/api.service';
import {EvaluationAdditionalQuestion} from '../models/models.lib';
const { apiUrl } = environment;

export abstract class CasiEvaluationAdditionalQuestionService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(evaluationId: number): void {
    this.fetch(evaluationId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(evaluationId: number): Observable<EvaluationAdditionalQuestion[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/evaluation/additional/question/all/${evaluationId}`))
      .pipe(
        map((response: any, i) => {
          return <EvaluationAdditionalQuestion[]>response;
        }),
        map(r => r.map(x => EvaluationAdditionalQuestion.create(x))),
        tap(() => (this.loading = false))
      )
  }
}



@Injectable({
  providedIn: 'root'
})
export class EvaluationAdditionalQuestionService     extends CasiEvaluationAdditionalQuestionService  {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(evaluationId: number) {
    return this.apiService.getHttpCall(`evaluation/additional/all/question/${evaluationId}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('evaluation/additional/question', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`evaluation/additional/question/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`evaluation/additional/question/${id}` , 'destroy');
  }

  moveDown(id: number): Promise<any>  {
    return this.apiService.getHttpCallAsPromise(`evaluation/additional/question/move/down/${id}`, 'moveDown');
  }

  moveUp(id: number): Promise<any>  {
    return this.apiService.getHttpCallAsPromise(`evaluation/additional/question/move/up/${id}`, 'moveUp');
  }
}

